import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    api.post("/auth/google", { session_id: sessionId })
      .then(({ data }) => { setUser(data); navigate("/", { replace: true }); })
      .catch((e) => {
        setError(formatError(e));
        setUser(false);
        window.history.replaceState(null, "", "/login");
      });
  }, [hash, navigate, setUser]);

  if (error)
    return (
      <div className="min-app-shell flex flex-col items-center justify-center gap-4 p-6 text-center" data-testid="google-auth-error">
        <p className="text-red-400 max-w-md">{error}</p>
        <a href="/login" className="text-primary hover:underline">Back to sign in</a>
      </div>
    );
  return <div className="min-app-shell flex items-center justify-center"><Loader2 className="animate-spin text-primary" /></div>;
}
